/* eslint-disable */
// src/forms/machine/updateMachineForm.js

import React, { Component } from "react";
import machineService from "../../services/machineService";
import PropTypes from "prop-types";
import { Button, TextField, Grid, Paper } from "@mui/material";
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";

class UpdateMachineForm extends Component {
  constructor(props) {
    super(props);

    const { machine } = props;

    this.state = {
      nameError: "",
      machine: {
        Id: machine.Id,
        Name: machine.Name || "",
      },
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    if (name !== "Name") return;

    this.setState((prev) => ({
      machine: { ...prev.machine, Name: value },
      nameError: "",
    }));
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.state.machine.Name?.trim()) {
      this.setState({ nameError: "Ingresá un nombre." });
      return;
    }

    try {
      await machineService.updateMachine(this.state.machine.Id, {
        Name: this.state.machine.Name,
      });

      await this.props.onUpdateSuccess?.(this.state.machine.Id);
      this.props.closeForm();
    } catch (error) {
      console.error("Error al actualizar la máquina:", error);
    }
  };

  render() {
    const { machine } = this.state;

    return (
      <Paper style={{ padding: 20, marginTop: 10, width: "100%" }}>
        <form onSubmit={this.handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre"
                required
                error={Boolean(this.state.nameError)}
                helperText={this.state.nameError}
                name="Name"
                value={machine.Name}
                onChange={this.handleChange}
              />
            </Grid>

            {/* ===================== BOTONES FINALES ===================== */}
            <Grid item xs={12} sx={{ mt: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CancelButton onClick={this.props.closeForm} fullWidth>
                    Cancelar
                  </CancelButton>
                </Grid>

                <Grid item xs={12} md={6}>
                  <AcceptButton type="submit" fullWidth>
                    Guardar cambios
                  </AcceptButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  }
}

UpdateMachineForm.propTypes = {
  closeForm: PropTypes.func.isRequired,
  machine: PropTypes.object.isRequired,
  onUpdateSuccess: PropTypes.func,
};

export default UpdateMachineForm;
